var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("app-divider", { attrs: { label: "Dados do VTN", showBorder: true } }),
      _vm.isParcelaGeo
        ? _c(
            "div",
            _vm._l(_vm.parcelas, function(parcela, index) {
              return _c(
                "div",
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c("h4", [_vm._v(_vm._s(parcela.municipio.nome))])
                      ]),
                      _c(
                        "el-col",
                        {
                          staticClass: "container-input",
                          attrs: { md: 12, lg: 5 }
                        },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required|min_value:0.0001",
                              name: _vm.getName(index, "Área requerida")
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: "Área requerida (ha):",
                                          required: true
                                        }
                                      }),
                                      _c("app-double-input", {
                                        attrs: {
                                          hasValidationError: errors[0]
                                            ? true
                                            : false,
                                          precision: 4
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.setarParcelas(index)
                                          }
                                        },
                                        model: {
                                          value: parcela.areaRequerida,
                                          callback: function($$v) {
                                            _vm.$set(
                                              parcela,
                                              "areaRequerida",
                                              $$v
                                            )
                                          },
                                          expression: "parcela.areaRequerida"
                                        }
                                      }),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticClass: "container-input",
                          attrs: { md: 12, lg: 7 }
                        },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              name: _vm.getName(index, "Fator distância"),
                              mode: "lazy"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: "Fator de distância (IFa):",
                                          required: true
                                        }
                                      }),
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "input select",
                                          class: { erro: errors.length },
                                          attrs: {
                                            placeholder: "Selecione",
                                            "value-key": "id",
                                            name: "Fator distância",
                                            disabled: _vm.vtnExcedente,
                                            clearable: "clearable"
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.setarParcelas(index)
                                            }
                                          },
                                          model: {
                                            value: parcela.fatorDistancia,
                                            callback: function($$v) {
                                              _vm.$set(
                                                parcela,
                                                "fatorDistancia",
                                                $$v
                                              )
                                            },
                                            expression: "parcela.fatorDistancia"
                                          }
                                        },
                                        _vm._l(_vm.fatoresDistancia, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.id,
                                            attrs: {
                                              label: item.descricao,
                                              value: item
                                            }
                                          })
                                        }),
                                        1
                                      ),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticClass: "container-input",
                          attrs: { md: 12, lg: 7 }
                        },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              name: _vm.getName(index, "Fator Acesso"),
                              mode: "lazy"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: "Fator de acesso (IFb):",
                                          required: true
                                        }
                                      }),
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "input select",
                                          class: { erro: errors.length },
                                          attrs: {
                                            placeholder: "Selecione",
                                            "value-key": "id",
                                            name: "Fator acesso",
                                            disabled: _vm.vtnExcedente,
                                            clearable: "clearable"
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.setarParcelas(index)
                                            }
                                          },
                                          model: {
                                            value: parcela.fatorAcesso,
                                            callback: function($$v) {
                                              _vm.$set(
                                                parcela,
                                                "fatorAcesso",
                                                $$v
                                              )
                                            },
                                            expression: "parcela.fatorAcesso"
                                          }
                                        },
                                        _vm._l(_vm.fatoresAcesso, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.id,
                                            attrs: {
                                              label: item.descricao,
                                              value: item
                                            }
                                          })
                                        }),
                                        1
                                      ),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticClass: "container-input",
                          attrs: { md: 12, lg: 5 }
                        },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required|notZero",
                              name: _vm.getName(index, "Tempo de ocupação")
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: "Tempo de ocupação (ano):",
                                          required: true
                                        }
                                      }),
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "mask",
                                            rawName: "v-mask",
                                            value: ["###"],
                                            expression: "['###']"
                                          }
                                        ],
                                        staticClass: "input",
                                        class: { erro: errors.length },
                                        attrs: {
                                          placeholder: "0",
                                          disabled: _vm.vtnExcedente
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.setarParcelas(index)
                                          }
                                        },
                                        model: {
                                          value: parcela.tempoDeOcupacao,
                                          callback: function($$v) {
                                            _vm.$set(
                                              parcela,
                                              "tempoDeOcupacao",
                                              $$v
                                            )
                                          },
                                          expression: "parcela.tempoDeOcupacao"
                                        }
                                      }),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
            0
          )
        : _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { staticClass: "container-input", attrs: { md: 12, lg: 5 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: "required|min_value:0.0001",
                      name: "Área requerida"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          return [
                            _c("app-label", {
                              attrs: {
                                label: _vm.vtnExcedente
                                  ? "Área requerida excedente (ha):"
                                  : "Área requerida (ha):",
                                required: true
                              }
                            }),
                            _c("app-double-input", {
                              attrs: {
                                hasValidationError: errors[0] ? true : false,
                                precision: 4
                              },
                              model: {
                                value: _vm.areaRequerida,
                                callback: function($$v) {
                                  _vm.areaRequerida = $$v
                                },
                                expression: "areaRequerida"
                              }
                            }),
                            _c("span", { staticClass: "help erro" }, [
                              _vm._v(_vm._s(errors[0]))
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "container-input", attrs: { md: 12, lg: 7 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: "required",
                      name: "Fator distância",
                      mode: "lazy"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          return [
                            _c("app-label", {
                              attrs: {
                                label: "Fator de distância (IFa):",
                                required: true
                              }
                            }),
                            _c(
                              "el-select",
                              {
                                staticClass: "input select",
                                class: { erro: errors.length },
                                attrs: {
                                  placeholder: "Selecione",
                                  "value-key": "id",
                                  name: "Fator distância",
                                  disabled: _vm.vtnExcedente,
                                  clearable: "clearable"
                                },
                                model: {
                                  value: _vm.fatorDistancia,
                                  callback: function($$v) {
                                    _vm.fatorDistancia = $$v
                                  },
                                  expression: "fatorDistancia"
                                }
                              },
                              _vm._l(_vm.fatoresDistancia, function(item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.descricao, value: item }
                                })
                              }),
                              1
                            ),
                            _c("span", { staticClass: "help erro" }, [
                              _vm._v(_vm._s(errors[0]))
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "container-input", attrs: { md: 12, lg: 7 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: "required",
                      name: "Fator Acesso",
                      mode: "lazy"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          return [
                            _c("app-label", {
                              attrs: {
                                label: "Fator de acesso (IFb):",
                                required: true
                              }
                            }),
                            _c(
                              "el-select",
                              {
                                staticClass: "input select",
                                class: { erro: errors.length },
                                attrs: {
                                  placeholder: "Selecione",
                                  "value-key": "id",
                                  name: "Fator acesso",
                                  disabled: _vm.vtnExcedente,
                                  clearable: "clearable"
                                },
                                model: {
                                  value: _vm.fatorAcesso,
                                  callback: function($$v) {
                                    _vm.fatorAcesso = $$v
                                  },
                                  expression: "fatorAcesso"
                                }
                              },
                              _vm._l(_vm.fatoresAcesso, function(item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.descricao, value: item }
                                })
                              }),
                              1
                            ),
                            _c("span", { staticClass: "help erro" }, [
                              _vm._v(_vm._s(errors[0]))
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "container-input", attrs: { md: 12, lg: 5 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: "required|notZero",
                      name: "Tempo de ocupação"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          return [
                            _c("app-label", {
                              attrs: {
                                label: "Tempo de ocupação (ano):",
                                required: true
                              }
                            }),
                            _c("el-input", {
                              directives: [
                                {
                                  name: "mask",
                                  rawName: "v-mask",
                                  value: ["###"],
                                  expression: "['###']"
                                }
                              ],
                              staticClass: "input",
                              class: { erro: errors.length },
                              attrs: { disabled: _vm.vtnExcedente },
                              model: {
                                value: _vm.tempoOcupacao,
                                callback: function($$v) {
                                  _vm.tempoOcupacao = $$v
                                },
                                expression: "tempoOcupacao"
                              }
                            }),
                            _c("span", { staticClass: "help erro" }, [
                              _vm._v(_vm._s(errors[0]))
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
      _vm.tipoProcesso === "ONEROSO" && !_vm.vtnExcedente
        ? _c("el-row", [
            _c(
              "div",
              { staticClass: "container-input termo" },
              [
                _c(
                  "el-checkbox",
                  {
                    staticClass: "check",
                    model: {
                      value: _vm.respeitaLegislacaoAmbiental,
                      callback: function($$v) {
                        _vm.respeitaLegislacaoAmbiental = $$v
                      },
                      expression: "respeitaLegislacaoAmbiental"
                    }
                  },
                  [
                    _c("span", {
                      staticClass: "checkbox-label",
                      domProps: { innerHTML: _vm._s(_vm.labelRespeita) }
                    })
                  ]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "container-input termo" },
              [
                _c(
                  "el-checkbox",
                  {
                    staticClass: "check",
                    model: {
                      value: _vm.temDireitoRegularizacao,
                      callback: function($$v) {
                        _vm.temDireitoRegularizacao = $$v
                      },
                      expression: "temDireitoRegularizacao"
                    }
                  },
                  [
                    _c("span", {
                      staticClass: "checkbox-label",
                      domProps: { innerHTML: _vm._s(_vm.labelTemDireito) }
                    })
                  ]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40cef494", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40cef494","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/financeiro/vtn/DadosVtn.vue
// module id = null
// module chunks = 